import React, { useState, useEffect, useReducer } from 'react';
import logo from './logo.svg';
import './App.css';
import 'antd/dist/antd.css';
import './pages/common/style';

import { getListEnabled } from './services/Entity';
import { Alert, Drawer, Layout, Menu, Avatar, Dropdown, Badge, Button, Modal, message, notification } from 'antd';
import { BrowserRouter as Router, NavLink, Route } from 'react-router-dom';
import { Loadding, Page } from './components';
import { default as PackageNew } from './supplier/home/packageNew';
import { downloadDeliveryPost, downloadPackage, getPackageNo, getOrderPackageList, syncOrderPackageNo, getOrderGoodsList, returnOrderPackageNo } from './services/Order';
import {
  LogoutOutlined,
  FileDoneOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  SettingOutlined,
  HomeOutlined,
  UserOutlined,
  CaretDownOutlined,
  BellOutlined,
  SolutionOutlined,
  CarOutlined,
  QuestionOutlined,
  PieChartOutlined,
  DatabaseOutlined,
  UserSwitchOutlined,
  KeyOutlined,
  ClearOutlined,
  ProfileOutlined,
  CalendarOutlined,
  ExclamationCircleOutlined,
  DownloadOutlined,
  FileSyncOutlined
} from '@ant-design/icons';

import { getList as getNotificationList, putNotificationStatus } from './services/Notification';
import { parsePackageList } from './utils/Report';
import Loadable from 'react-loadable';
const Home = Loadable({ loader: () => import('./pages/home'), loading: Loadding });
const Order = Loadable({ loader: () => import('./pages/order'), loading: Loadding });
const Buyer = Loadable({ loader: () => import('./pages/buyer'), loading: Loadding });
const Goods = Loadable({ loader: () => import('./pages/goods'), loading: Loadding });
const Supplier = Loadable({ loader: () => import('./pages/supplier'), loading: Loadding });
const Stat = Loadable({ loader: () => import('./pages/stat'), loading: Loadding });
const Setting = Loadable({ loader: () => import('./pages/setting'), loading: Loadding });
const Delivery = Loadable({ loader: () => import('./pages/delivery'), loading: Loadding });

const { Header, Sider } = Layout;

export const MasterContext = React.createContext(null);
function App(props) {
  const { user, authorities } = props;
  const [collapsed, setCollapsed] = useState(true);
  const [alert, setAlert] = useState({});
  const [packages, setPackages] = useState([]);
  const [packageNo, setPackageNo] = useState({});
  const [selectedNotification, setSelectedNotification] = useState({});
  const [isShowNotification, setShowNotification] = useState(false);
  const [isShowDeliveryPlan, setShowDeliveryPlan] = useState(false);
  const [isShowPackageList, setShowPackageList] = useState(false);
  const [goods, setGoods] = useState([]);
  const parsePackages = (rows) => {
    const tempPallets = [];
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      if (tempPallets.indexOf(row.pallet_id) < 0 && row.pallet_id > 0) {
        tempPallets.push(row.pallet_id);
      }
      const find = goods.find(x => x.goods_spec_id === row.goods_spec_id);
      if (find) {
        row.goods_id = find.goods_id;
        row.goods_spec_id = find.goods_spec_id;
        row.goods_name = find.goods_name;
        row.size = find.size;
        row.weight = find.weight;
        row.price = find.price;
        row.pcs_per_carton = find.pcs_per_carton;
        row.carton_count_per_pallet = find.carton_count_per_pallet;
      }
    }

    let temp = [];
    tempPallets.forEach(x => {
      const f = rows.filter(y => y.pallet_id === x);
      if (f.length > 0) {
        f[0].isPallet = 1;
        temp = temp.concat(f);
      }
    })
    //if (tempPallets.length > 0) temp.push({});
    const c = rows.filter(y => y.pallet_id === -1);
    if (c.length > 0) {
      c[0].isPallet = -1;
      temp = temp.concat(c);
    }
    temp.push({});
    return temp;
  }

  const returnPackage = (no, order_id, package_id) => {
    Modal.confirm({
      title: `该箱单号所有装箱信息会全部退回供应商?`,
      icon: <ExclamationCircleOutlined />,
      content: <strong>{no}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        const key = 'return_package_no';
        message.loading({ content: '正在退回箱单号...', key });
        returnOrderPackageNo(order_id, package_id).then(() => {
          getPackageNo(packageNo.order_id, packageNo.supplier_id, packageNo.id).then(data => setPackageNo(data));
          message.success({ content: `退回箱单号成功`, key, duration: 2 });
        })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onSyncPackageList = (e) => {
    // If you don't want click extra trigger collapse, you can prevent this:
    e.stopPropagation();
    Modal.confirm({
      title: `确定同步当前装箱单吗?`,
      icon: <ExclamationCircleOutlined />,
      content: <strong>{packageNo.no}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        const key = 'sync_package';
        message.loading({ content: '正在同步装箱单...', key });
        syncOrderPackageNo(packageNo.order_id, packageNo.id).then(() => {
          getPackageNo(packageNo.order_id, packageNo.supplier_id, packageNo.id).then(data => setPackageNo(data));
          message.success({ content: `装箱单同步完成`, key, duration: 2 });
        });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }


  const downloadPackagePost = (order, no, rows) => {
    const body = parsePackageList(rows, {
      no: no.no,
      goods_code: no.goods_code || '',
      buyer_name: no.buyer_name,
      po_code: no.po_code,
      sdate: no.date,
      supplier_name: no.supplier_name,
      delivery_date: no.delivery_date,
      remark: no.remark,
      pallet_flag: no.pallet_flag
    });
    const key = 'download';
    message.loading({ content: '正在生成装箱单...', key, duration: 20 });
    downloadDeliveryPost(order.id, no.id, body).then(data => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = '装箱单_' + order.po + '_' + no.no;
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放 URL对象
        document.body.removeChild(elink);
        message.success({ content: `装箱单下载成功`, key, duration: 2 });
      }
    });

  }

  const downloadOrderPackage = (order, no) => {
    const key = 'download';
    message.loading({ content: '正在生成装箱单...', key, duration: 20 });
    downloadPackage(no.order_id, no.id).then(data => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = '装箱单_' + selectedNotification.args.po + '_' + no.no;
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放 URL对象
        document.body.removeChild(elink);
        message.success({ content: `装箱单下载成功`, key, duration: 2 });
      }
    });
  }
  const toggleNotification = (isShow) => {
    getNotificationList().then(data => dispatch({ type: 'notification', data: data }));
    setShowNotification(isShow);
  }
  const toggleNotificationStatus = (notification) => {

    putNotificationStatus(notification.id, { status: 1 }).then(() => {
      getNotificationList().then(data => dispatch({ type: 'notification', data: data }));
    });
    if (notification.args && notification.args.type === "json") {
      const args = JSON.parse(notification.args.value);
      setSelectedNotification({ ...notification, args: args });
      getPackageNo(args.order_id, args.supplier_id, args.package_id).then(data => {
        if (data) {
          setPackageNo(data);
          getOrderGoodsList(args.order_id).then(data => setGoods(data));
          getOrderPackageList(
            args.order_id
          ).then(data => {
            setPackages(
              parsePackages(data.filter(x => x.package_id === args.package_id).map(y => ({ ...y, cartonCount: y.count > 0 ? y.count / y.pcs_per_carton : undefined, pcsPerCarton: y.pcs_per_carton }))
              ));
            setShowPackageList(true);
          });
        } else {
          Modal.error({
            title: '数据不存在',
            content: '装箱单已被删除，请联系供应商确认！',
          });
        }
      });
    }
  }
  const nav = [
    {
      key: 'nav_home',
      label: '首页',
      to: '/',
      icon: <HomeOutlined />
    },
    {
      key: 'nav_order',
      label: '订单管理',
      to: '/order',
      icon: <FileDoneOutlined />
    },
    {
      key: 'nav_delivery',
      label: '发货管理',
      to: '/delivery',
      icon: <CarOutlined />
    },
    {
      key: 'nav_goods',
      label: '产品管理',
      to: '/goods',
      icon: <DatabaseOutlined />
    },
    {
      key: 'nav_buyer',
      label: '客户管理',
      to: '/buyer',
      icon: <UserSwitchOutlined />
    },
    {
      key: 'nav_supplier',
      label: '供应商管理',
      to: '/supplier',
      icon: <SolutionOutlined />
    },
    {
      key: 'nav_stat',
      label: '统计报表',
      to: '/stat',
      icon: <PieChartOutlined />
    },
    {
      key: 'nav_setting',
      label: '系统设置',
      to: '/setting',
      icon: <SettingOutlined />
    },
  ].filter(x => authorities.find(y => x.key === y) || user.category_id === 1);

  function reducer(state, action) {
    switch (action.type) {
      case 'notification':
        return Object.assign({}, state, { notification: action.data });
      case 'company':
        return Object.assign({}, state, { company: action.data });
      case 'user':
        return Object.assign({}, state, { user: action.data });
      case 'user_category':
        return Object.assign({}, state, { user_category: action.data });
      // case 'surface':
      //   return Object.assign({}, state, { surface: action.data });
      case 'warehouse':
        return Object.assign({}, state, { warehouse: action.data });
      case 'goods_category':
        return Object.assign({}, state, { goods_category: action.data });
      case 'country':
        return Object.assign({}, state, { country: action.data });
      case 'port':
        return Object.assign({}, state, { port: action.data });
      case 'transport':
        return Object.assign({}, state, { transport: action.data });
      case 'container':
        return Object.assign({}, state, { container: action.data });
      case 'currency':
        return Object.assign({}, state, { currency: action.data });
      case 'currency_rate':
        return Object.assign({}, state, { currency_rate: action.data });
      //case 'unit':
      //  return Object.assign({}, state, { unit: action.data });
      case 'payment':
        return Object.assign({}, state, { payment: action.data });
      case 'shipmark':
        return Object.assign({}, state, { shipmark: action.data });
      default:
        throw new Error();
    }
  }

  const [state, dispatch] = useReducer(reducer, {
    notification: [],
    company: [],
    country: [],
    currency: [],
    port: [],
    transport: [],
    container: [],
    payment: [],
    currency_rate: [],
    goods_category: [],
    warehouse: [],
    shipmark: [],
    surface: [],
    user_category: [],
    user: [],
    authorities: authorities,
    currentUser: user,
    showAlert: () => {

    },
    reload: (entity) => {
      getListEnabled('fm_' + entity).then(data => dispatch({ type: entity, data: data }));
    }
  });

  const [count, setCount] = useState(0);

  useEffect(() => {
    const i = setInterval(testando, 1000 * 60);
    return () => clearInterval(i);
  }, []);

  const testando = () => {
    getNotificationList().then(data => {
      dispatch({ type: 'notification', data: data });
    });
    setCount((prev) => prev + 1);
  };

  useEffect(() => {
    getNotificationList().then(data => {
      dispatch({ type: 'notification', data: data });
    });
    getListEnabled('fm_company').then(data => dispatch({ type: 'company', data: data }));
    getListEnabled('fm_user').then(data => dispatch({ type: 'user', data: data }));
    getListEnabled('fm_user_category').then(data => dispatch({ type: 'user_category', data: data }));
    getListEnabled('fm_currency_rate').then(data => dispatch({ type: 'currency_rate', data: data }));
    getListEnabled('fm_warehouse').then(data => dispatch({ type: 'warehouse', data: data }));
    getListEnabled('fm_country').then(data => dispatch({ type: 'country', data: data }));
    getListEnabled('fm_currency').then(data => dispatch({ type: 'currency', data: data }));
    getListEnabled('fm_port').then(data => dispatch({ type: 'port', data: data }));
    getListEnabled('fm_transport').then(data => dispatch({ type: 'transport', data: data }));
    getListEnabled('fm_container').then(data => dispatch({ type: 'container', data: data }));
    getListEnabled('fm_payment').then(data => dispatch({ type: 'payment', data: data }));
    getListEnabled('fm_goods_category').then(data => dispatch({ type: 'goods_category', data: data }));
    getListEnabled('fm_shipmark').then(data => dispatch({ type: 'shipmark', data: data }));
  }, []);

  const logout = () => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    window.location.href = 'http://auth.tmrmetal.com/auth/logout?redirect_uri=/';
  }

  const menu = (
    <Menu style={{ padding: '0 1.5rem', margin: '0.5rem 1.5rem' }}>
      <Menu.Item key="0" icon={<ProfileOutlined />}>
        <a href={`http://auth.tmrmetal.com/auth/profile?redirect_uri=${window.location.href}`}>个人信息</a>
      </Menu.Item>
      <Menu.Item key="1" icon={<KeyOutlined />}>
        <a href={`http://auth.tmrmetal.com/auth/editpw?redirect_uri=${window.location.href}`}>修改密码</a>
      </Menu.Item>
      <Menu.Item key="2" icon={<ClearOutlined />}>
        <a href="">清除缓存</a>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="3" icon={<LogoutOutlined />} onClick={logout}> 退出系统 </Menu.Item>
    </Menu>
  );

  return (
    <MasterContext.Provider value={state}>
      <Router>
        <Layout style={{ minHeight: '100%' }}>
          {/* <Affix className="trash">
            <CalendarOutlined style={{ fontSize: '2rem', color: 'white' }} />
          </Affix> */}
          <Sider trigger={null} collapsible collapsed={collapsed}>
            <div className="components-layout-demo-custom-trigger">
              <div className="logo"></div>
              <Menu theme="dark" mode="inline" defaultSelectedKeys={[window.location.pathname]}>
                {
                  nav.map((item) => {
                    return (
                      <Menu.Item key={item.to} icon={item.icon}>
                        <NavLink to={item.to} >{item.label}</NavLink>
                      </Menu.Item>
                    )
                  })
                }
              </Menu>
            </div>
          </Sider>
          <Layout className="site-layout">
            <Header className="site-layout-background" style={{ padding: 0 }}>
              <div className="components-layout-demo-custom-trigger" style={{ display: 'flex', height: '100%', alignItems: 'center' }}>
                {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                  className: 'trigger',
                  onClick: () => setCollapsed(!collapsed),
                })}
                <div style={{ fontSize: '1.5rem', fontWeight: '600', display: 'flex', alignItems: 'center', color: 'rgb(0,0,0,0.6)' }}>订单管理系统V1.0</div>
                <div style={{ marginLeft: 'auto' }} />
                <div style={{ display: 'flex', alignItems: 'center', width: '60px', cursor: 'pointer' }}>
                  <Avatar
                    onClick={undefined} icon={<QuestionOutlined />} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', width: '60px', cursor: 'pointer' }}>
                  <Badge>
                    <Avatar style={{ backgroundColor: '#87d068' }}
                      onClick={() => setShowDeliveryPlan(true)} icon={<CalendarOutlined />} />
                  </Badge>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', width: '60px', cursor: 'pointer' }}>
                  <Badge count={state.notification.filter(x => x.status === 0).length}>
                    <Avatar style={{ backgroundColor: '#1890ff' }}
                      onClick={() => toggleNotification(true)} icon={<BellOutlined />} />
                  </Badge>
                </div>
                <Dropdown placement="bottomLeft" overlay={menu} trigger={['click']}>
                  <div style={{ padding: '0 16px', lineHeight: 1, borderLeft: '2px solid #f4f4f4', display: 'flex', alignItems: 'center', minWidth: '140px', cursor: 'pointer' }}>
                    <Avatar style={{ marginRight: '8px' }} icon={<UserOutlined />} />
                    <div style={{ display: 'inline-flex', alignItems: 'center' }} className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                      <div>
                        <div>{user.name}</div>
                        <div>{user.email}</div>
                      </div>
                      <CaretDownOutlined />
                    </div>

                  </div>
                </Dropdown>
              </div>
            </Header>
            {(authorities.find(x => x === 'nav_home') || user.category_id === 1) && <Route exact path="/" component={Home} />}
            {(authorities.find(x => x === 'nav_order') || user.category_id === 1) && <Route path="/order" component={Order} />}
            {(authorities.find(x => x === 'nav_buyer') || user.category_id === 1) && <Route path="/buyer" component={Buyer} />}
            {(authorities.find(x => x === 'nav_goods') || user.category_id === 1) && <Route path="/goods" component={Goods} />}
            {(authorities.find(x => x === 'nav_supplier') || user.category_id === 1) && <Route path="/supplier" component={Supplier} />}
            {(authorities.find(x => x === 'nav_delivery') || user.category_id === 1) && <Route path="/delivery" component={Delivery} />}
            {(authorities.find(x => x === 'nav_stat') || user.category_id === 1) && <Route path="/stat" component={Stat} />}
            {(authorities.find(x => x === 'nav_setting') || user.category_id === 1) && <Route path="/setting" component={Setting} />}
          </Layout>
        </Layout>
      </Router>
      {
        alert.show && <Alert
          message={alert.message + 'ssss'}
          type={alert.type + 'warnning'}
          closable
        />
      }
      <Drawer
        title="通知消息"
        placement="right"
        width={480}
        closable={true}
        onClose={() => setShowNotification(false)}
        open={isShowNotification}
      >
        {
          state.notification.map(x => {
            return <p
              style={{ cursor: 'pointer' }}
              onClick={() => toggleNotificationStatus(x)}>
              [{x.status === 0 ? <span style={{ color: 'green' }}>未读</span> : '已读'}]&nbsp;
              <strong>{x.title}</strong>
              <small>{x.sub_title}</small> <br />
              <small>{x.content}</small>
            </p>
          })
        }
      </Drawer>
      <Drawer
        title="发货计划【周视图】"
        placement="right"
        width={720}
        closable={true}
        onClose={() => setShowDeliveryPlan(false)}
        open={isShowDeliveryPlan}
      >
        <p>Some contents...</p>
        <p>Some contents...</p>
        <p>Some contents...</p>
      </Drawer>
      <Page
        title={`${selectedNotification.title}  ${selectedNotification.sub_title}`}
        width="1400px"
        onCloseCallback={() => setShowPackageList(false)}
        body={
          <div>
            <div style={{ padding: '1rem 1rem 0 1rem' }}>
              <PackageNew
                key={selectedNotification.id}
                supplier={{}}
                mode="view"
                packageId={undefined}
                packageList={{}}
                rows={packages}
                goods={[]}
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'end', padding: '0 1rem 1rem 1rem' }}>
              <Button onClick={() => setShowPackageList(false)} style={{ marginLeft: 'auto', marginRight: '1rem' }}>关 闭</Button>
              {packageNo.status === 0 && <Button onClick={() => returnPackage(packageNo.no, packageNo.order_id, packageNo.id)} danger style={{ marginRight: '1rem' }}>退回装箱单</Button>}
              <Button onClick={() => downloadPackagePost({ id: packageNo.order_id, po: selectedNotification.args.po }, packageNo, packages.map(x => ({ ...x, weight: x.weight * x.count * 0.001 })))} style={{ marginRight: '1rem' }} icon={<DownloadOutlined />} type="secondary">下载装箱单</Button>
              <Button onClick={onSyncPackageList} disabled={packageNo.status === 1 || packageNo.status === 2} icon={<FileSyncOutlined />} type="primary">{packageNo.status === 1 ? '已同步' : packageNo.status === 2 ? '已退回' : '同步装箱单'}</Button>
            </div>
          </div>
        }
        visible={isShowPackageList}
      />
    </MasterContext.Provider >
  );
}

export default App;
